class GpsDistService {
    calcDist(lat1, lon1, lat2, lon2) {
        const R = 6371000; // Rayon de la Terre en km
        const toRad = (angle) => (angle * Math.PI) / 180;
    
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
    
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
    
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    
        return R * c; // Distance en km
    }
}

export default new GpsDistService();

